import type PinnedLocation from "src/types/PinnedLocation";
import { devtools, persist } from "zustand/middleware";

import { create } from "./helpers/resetStore.helper";

interface AppPinnedState {
  appPinned: PinnedLocation[];
  setAppPinned: (pinned: PinnedLocation[]) => void;
  reset: () => void;
}

const useAppPinnedStore = create<AppPinnedState>(
  devtools(
    persist(
      (set) => ({
        appPinned: [],
        setAppPinned: (pinned: PinnedLocation[]) => {
          set({ appPinned: pinned });
        },
        reset: () => {
          set({ appPinned: [] });
        },
      }),
      { name: "app-pinned-storage" }
    )
  )
);

export default useAppPinnedStore;
